(() => {
  if (window.__sqMenuSearchEnrichmentV1) return;
  window.__sqMenuSearchEnrichmentV1 = true;

  const MAX_CARDS = 99;
  const QUERIES = {
    '/collections/polished-blouses': 'blouse shirt',
    '/collections/polished-shorts': 'shorts',
    '/collections/leggings': 'leggings',
    '/collections/denim-icons': 'denim',
    '/collections/polished-skirts': 'skirt',
    '/collections/cardigans': 'cardigan',
    '/collections/polished-blazers': 'blazer',
    '/collections/signature-jackets': 'jacket',
  };

  const pageCache = new Map();
  const metaCache = new Map();
  const tokens = new WeakMap();
  const bound = new WeakSet();

  function random(max) {
    if (max <= 1) return 0;
    if (window.crypto?.getRandomValues) {
      const value = new Uint32Array(1);
      window.crypto.getRandomValues(value);
      return value[0] % max;
    }
    return Math.floor(Math.random() * max);
  }

  function shuffle(items) {
    const result = items.slice();
    for (let index = result.length - 1; index > 0; index -= 1) {
      const swap = random(index + 1);
      [result[index], result[swap]] = [result[swap], result[index]];
    }
    return result;
  }

  function submenuFor(anchor) {
    return anchor.closest('.menu-list__submenu') ||
      anchor.closest('.menu-list__list-item')?.querySelector(':scope > .menu-list__submenu') ||
      null;
  }

  function parse(html) {
    const documentObject = new DOMParser().parseFromString(html, 'text/html');
    const root = documentObject.querySelector('[data-sq-menu-search-results]');
    if (!root) return { cards: [], pages: 1 };
    return {
      cards: Array.from(root.querySelectorAll('.sq-menu-product-card')).map((card) => card.cloneNode(true)),
      pages: Math.max(1, Number(root.dataset.pages || 1)),
    };
  }

  async function searchPage(query, page) {
    const key = `${query}|${page}`;
    if (pageCache.has(key)) return pageCache.get(key).map((card) => card.cloneNode(true));

    const url = new URL('/search', window.location.origin);
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    url.searchParams.set('view', 'sq-menu');
    url.searchParams.set('page', String(page));
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error(`Search enrichment failed: ${response.status}`);
    const parsed = parse(await response.text());
    metaCache.set(query, parsed.pages);
    pageCache.set(key, parsed.cards);
    return parsed.cards.map((card) => card.cloneNode(true));
  }

  async function randomSearchPage(query) {
    const pages = metaCache.get(query);
    return searchPage(query, pages ? random(pages) + 1 : 1);
  }

  function mergeIntoPreview(anchor, cards, token, retry = true) {
    const submenu = submenuFor(anchor);
    const preview = submenu?.querySelector('[data-sq-menu-product-preview]');
    const track = preview?.querySelector('[data-sq-menu-preview-track]');
    if (!preview || !track) {
      if (retry) window.setTimeout(() => mergeIntoPreview(anchor, cards, token, false), 140);
      return;
    }
    if (tokens.get(preview) !== token) return;

    const combined = [...track.children, ...cards];
    const unique = [];
    const seen = new Set();
    for (const card of combined) {
      const key = card.dataset.productKey || (card.getAttribute('href') || '').replace(/[?#].*$/, '');
      if (!key || seen.has(key)) continue;
      seen.add(key);
      unique.push(card);
    }

    const fragment = document.createDocumentFragment();
    shuffle(unique).slice(0, MAX_CARDS).forEach((card, index) => {
      const image = card.querySelector('img');
      if (image) image.loading = index < 4 ? 'eager' : 'lazy';
      fragment.appendChild(card);
    });
    track.replaceChildren(fragment);
    const hint = preview.querySelector('.sq-menu-product-preview__hint');
    if (hint) hint.textContent = `Swipe to browse ${track.children.length} unique products`;
  }

  async function enrich(anchor, query) {
    const submenu = submenuFor(anchor);
    if (!submenu) return;
    let preview = submenu.querySelector('[data-sq-menu-product-preview]');
    if (!preview) {
      await new Promise((resolve) => window.setTimeout(resolve, 110));
      preview = submenu.querySelector('[data-sq-menu-product-preview]');
    }
    if (!preview) return;

    const token = (tokens.get(preview) || 0) + 1;
    tokens.set(preview, token);
    try {
      const cards = await randomSearchPage(query);
      window.setTimeout(() => mergeIntoPreview(anchor, cards, token), 180);
    } catch (error) {
      console.warn('[Serein Queen collection enrichment]', error);
    }
  }

  function bindAnchor(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || bound.has(anchor)) return;
    let pathname;
    try { pathname = new URL(anchor.href, window.location.origin).pathname; } catch (_) { return; }
    const query = QUERIES[pathname];
    if (!query) return;
    bound.add(anchor);
    anchor.addEventListener('pointerenter', () => enrich(anchor, query), true);
    anchor.addEventListener('focus', () => enrich(anchor, query), true);
  }

  function bind(root = document) {
    root.querySelectorAll?.('#header-component .mega-menu__link[href]').forEach(bindAnchor);
    if (root.matches?.('#header-component .mega-menu__link[href]')) bindAnchor(root);
  }

  function start() {
    bind();
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) bind(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
